import {
  ApiResponseError,
  ApiSessionTimeoutError,
  classifyApiError,
  unwrapResponseModel
} from '../api/responseModel';
import {
  isCalendarDateOnOrAfter,
  serializeDateForApi
} from '../dates/dateService';

export {
  ApiResponseError as CursadasApiError,
  ApiSessionTimeoutError as CursadasSessionTimeoutError,
  classifyApiError as classifyCursadasError,
  unwrapResponseModel
};

export function toCreateCursadaPayload({ materiaCarreraCod, periodoCursadaCod }) {
  return {
    MateriaCarreraCod: materiaCarreraCod,
    PeriodoCursadaCod: periodoCursadaCod
  };
}

export function toUpdateCursadaPayload({ cursadaCod, materiaCarreraCod, periodoCursadaCod }) {
  return {
    CursadaCod: cursadaCod,
    MateriaCarreraCod: materiaCarreraCod,
    PeriodoCursadaCod: periodoCursadaCod
  };
}

export function toGenerarCursadasPayload({
  startDateAnual,
  endDateAnual,
  startDate1C,
  endDate1C,
  startDate2C,
  endDate2C
}) {
  return {
    FechaInicioAnual: serializeDateForApi(startDateAnual),
    FechaFinAnual: serializeDateForApi(endDateAnual),
    FechaInicio1C: serializeDateForApi(startDate1C),
    FechaFin1C: serializeDateForApi(endDate1C),
    FechaInicio2C: serializeDateForApi(startDate2C),
    FechaFin2C: serializeDateForApi(endDate2C)
  };
}

export function validateCursadaForm({ materiaPresent, periodoPresent }) {
  return Boolean(materiaPresent && periodoPresent);
}

export function validateDictadoMatch(materiaDictado, periodoDictado) {
  return materiaDictado == periodoDictado;
}

export function validateGenerarCursadasDates({
  startDateAnual,
  endDateAnual,
  startDate1C,
  endDate1C,
  startDate2C,
  endDate2C
}) {
  return (
    isCalendarDateOnOrAfter(endDateAnual, startDateAnual)
    && isCalendarDateOnOrAfter(endDate1C, startDate1C)
    && isCalendarDateOnOrAfter(endDate2C, startDate2C)
  );
}
